module.exports = __webpack_public_path__ + "img/secret_step_2.5a3e92b2.svg";